import { Component, computed, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { toSignal } from '@angular/core/rxjs-interop';
import { NavigationEnd, PRIMARY_OUTLET, Router, RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { filter, map } from 'rxjs/operators';
import { FaDuotoneIconComponent } from '@fortawesome/angular-fontawesome';
import { PageTitleComponent } from '../../../../parts/page-title/page-title.component';
import { ReportsConstants } from '../../../../core/constants/reports.constants';
import { ReportTab } from '../../../../core/models/ui/report-tab.model';

@Component({
	selector: 'ms-reports-layout',
	standalone: true,
	imports: [PageTitleComponent, CommonModule, RouterLink, RouterLinkActive, RouterOutlet, FaDuotoneIconComponent],
	templateUrl: './reports-layout.page.html',
	styleUrl: './reports-layout.page.scss'
})
export class ReportsLayoutPage {

	public readonly tabs: ReportTab[] = ReportsConstants.REPORT_TABS;

	// Bound as both the help text's id and the active tab's aria-describedby, so the description
	// is announced when the tab it belongs to takes focus. (DEV-2703)
	public readonly descriptionElementId = 'reports-tab-description';

	private readonly router = inject(Router);

	private readonly activeUrl = toSignal(
		this.router.events.pipe(
			filter(event => event instanceof NavigationEnd),
			map(() => this.router.url)
		),
		{ initialValue: this.router.url }
	);

	public readonly activeTab = computed<ReportTab | undefined>(() => {
		const segments = this.router.parseUrl(this.activeUrl()).root.children[PRIMARY_OUTLET]?.segments ?? [];
		const activePath = segments[segments.length - 1]?.path;
		return this.tabs.find(tab => tab.path === activePath);
	});
}
